module.exports = __webpack_public_path__ + "fonts/iconfont.54bd907.eot";